import React from 'react'
import BriefQuestionArrayInput from 'ui-shared/FormComponents/BriefQuestionArrayInput'
import Kdivider from 'ui-shared/LayoutComponents/Kdivider'
import KFormTab from 'ui-shared/WrappedInputs/KFormTab'

// FIXME: find out if we can change this any typing
const GeneralCfgTab: React.FC<any> = (props) => {
  // we need to remove these entries from the props to avoid triggering errors in the nested components
  const { undoable, saving, save, ...rest } = props

  return (
    <KFormTab {...rest} label="General">
      <Kdivider title="Brief Questions" />
      <BriefQuestionArrayInput
        source="generalService.brief"
        isGeneralQuestion
      />
    </KFormTab>
  )
}

export default GeneralCfgTab
